/**
 * Combine all reducers in this file and export the combined reducers.
 */

import { fromJS } from 'immutable';
import { combineReducers } from 'redux-immutable';
import { LOCATION_CHANGE } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form/immutable'; // Import from redux-form/immutable is required to use immutable.

import globalReducer from './containers/App/reducer';

import communityMessageReducer from './containers/CommunityMessageContainer/reducer';
import videoFeedReducer from './containers/VideoFeed/reducer';
import { CLEAR_SESSION_ERROR } from './containers/App/actions';

/*
 * routeReducer
 *
 * The reducer merges route location changes into our immutable state.
 * The change is necessitated by using react-router-redux@5
 *
 */

// Initial routing state
const routeInitialState = fromJS({
  location: null,
  authRedirect: null
});

/**
 * Merge route into the global application state
 */
function routeReducer(state = routeInitialState, action) {
  switch (action.type) {
    /* istanbul ignore next */
    case LOCATION_CHANGE:
      return state.merge({
        location: action.payload,
        authRedirect:
          action.payload.state && action.payload.state.from
            ? action.payload.state.from
            : state.get('authRedirect')
      });

    case CLEAR_SESSION_ERROR:
      return state.setIn(['location', 'state'], undefined);

    default:
      return state;
  }
}

/**
 * Creates the main reducer with the dynamically injected ones
 */
export default function createReducer(injectedReducers) {
  return combineReducers({
    route: routeReducer,
    global: globalReducer,
    form: formReducer,
    communityMessage: communityMessageReducer,
    videoFeed: videoFeedReducer,
    ...injectedReducers
  });
}



// WEBPACK FOOTER //
// ./src/reducers.js